<script lang="ts" setup>
const { data: commonData } = await useAsyncCommonData();

const refilProducts = computed(() =>
  // TODO: локализованный текст прямо в логике - очень плохо так делать
  commonData.value.products.filter(
    (product) => product.refillId !== null && product.name.includes('Рефил') && !product.secret,
  ),
);

const { t } = useI18n();

const DATA = {
  collection: [
    {
      title: 'Функция супер',
      text:
        'Функция супер, спасибо!\n' +
        'Единственное, для рефиллов-сывороток 50 млн я бы увеличила срок, за 3 месяца они не успевают закончиться как по мне (особенно ретинол). \n' +
        'Либо дать опцию выбирать как часто получать рефилл - 3 месяца или срок побольше..',
      rating: 5,
      recommend: true,
      nameUser: 'Елена',
    },
    {
      title: 'Интересная штука',
      text: 'Вы такие интересные штуки всегда придумываете! Вы классные 🥰',
      rating: 5,
      recommend: true,
      nameUser: 'Галина',
    },
    {
      title: 'Это гарантия',
      text:
        'Мне нравится и идея сокращения упаковки и сам процесс замены: тут открутить, здесь наклеить — приятные манипуляции с приятными банками. А ещё удобно проверять, сколько средства осталось 👌🏻\n' +
        'Подписка кайф! Для меня это гарантия, что моё любимое средство всегда будет в наличии и можно не закупаться впрок. \n' +
        'Видела коммент по поводу сроков. Ребят, всё индивидуально решается вообще без проблем. Можно перенести дату доставки',
      rating: 5,
      recommend: true,
      nameUser: 'Екатерина',
    },
    {
      title: 'Радуюсь выгоде',
      text:
        'У меня есть подписка на крем Rich. Уже получила 3 раза баночку, радуюсь такой выгоде 😁\n' +
        'А подписка действует на 1 вид рефила, или можно оформить несколько?',
      rating: 5,
      recommend: true,
      nameUser: 'Лера',
    },
    {
      title: 'Это очень удобно',
      text: 'Добавлю еще, что при подписке менеджер всегда звонит в нужную дату и уточняет, актуальна ли доставка или перенесем ее (для меня это очень удобно!). Думаю, вам тоже позвонят и скажут, что продукта нет в наличии.',
      rating: 5,
      recommend: true,
      nameUser: 'Татьяна',
    },
    {
      title: 'Скидка 30%',
      text: 'При подписке скидка 30%, вот и выгода! И ещё, уверенность, что любимое средство будет в наличии.',
      rating: 5,
      recommend: true,
      nameUser: 'Victory',
    },
  ],
  total: 4,
  rating: 5,
};
</script>

<template>
  <main class="subscribeProductPage">
    <Head>
      <Title>{{ t('title') }}</Title>
      <Meta property="og:title" :content="t('og_title')" />
    </Head>

    <SectionSubscriptionProductBanner />
    <LazyIdleSectionSubscriptionProductIdea hydrate-on-idle />
    <LazyIdleSectionSubscriptionProductSimple hydrate-on-idle />
    <LazyIdleSectionSubscriptionFAQ hydrate-on-idle />

    <LazyIdleSectionSubscriptionProductSentences
      hydrate-on-idle
      :products="refilProducts"
      with-show-more
      class="mainPage__productSentences"
    />
    <LazyIdleSectionSubscriptionReviews hydrate-on-idle class="subscribeProductPage__reviews" :reviews="DATA.collection" />
  </main>
</template>

<i18n>
ru:
  title: Подписка на рефилы
  og_title: Don't Touch My Skin - подписка на рефилы

en:
  title: Subscription for Refills
  og_title: Don't Touch My Skin - subscription for Refills
</i18n>

<style lang="scss">
.subscribeProductPage {
  &__reviews {
    margin-top: 80px;
  }
}
</style>
